export const getCitizensProPending = (state) => state.citizensPro?.pending
